import { parseBloomreachContent, parseBloomreachMeta, getCommonParams } from "../helpers/hooks/helpers/helpers.js";
function useBloomreachPageable({
  page,
  component
}) {
  const { pageable } = component.getModels();
  if (!pageable || !pageable.items) {
    return {
      refs: pageable?.items,
      data: {
        meta: {},
        content: { items: [] }
      }
    };
  }
  const documents = pageable.items.map((ref) => page.getContent(ref));
  const items = documents.map((doc) => ({
    ...page.isPreview() ? { document: doc } : {},
    ...parseBloomreachContent(doc?.getData())
  }));
  const meta = parseBloomreachMeta(component.getParameters());
  const commonParams = getCommonParams(meta);
  return {
    refs: pageable.items,
    data: {
      meta,
      content: { items },
      ...commonParams
    }
  };
}
export {
  useBloomreachPageable
};
//# sourceMappingURL=use-bloomreach-pageable.js.map
